import { useTypedParams } from '@sorare/routing';

import { Accept as AcceptLineupForm } from '#src/components/noCardRoute/AcceptLineupForm/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const Accept = () => {
  const { so5LineupId } = useTypedParams<PageParams>();

  return <AcceptLineupForm so5LineupId={so5LineupId} />;
};

export default Accept;
